export const COMMUNITY_CREATE_MODAL_HEIGHT_FACTOR = 0.68;
export const COMMUNITY_BASIC_INFO_FIELDS = [
  'community_id',
  'comunity_name',
  'address',
  'city',
  'state',
  'zip_code',
  'phone_number',
  'notes',
  'website',
  'year_opened',
  'google_map_location',
  'a_place_for_mom_id',
  'caring_url',
  'rental_types',
  'contracts',
];
